import { z } from "zod";

/**
 * M1 — how many proposals survive the four exclusions. ONBOARDING is
 * human-v-bot by design and never queued; directed rematches skip the queue;
 * proposals with no human seat are house matches. Mutually checkable against route 28.
 */
export const ArenaOpsMatchmakingUniverseResponseSchema = z.object({
  allProposals: z.number().int(),
  onboarding: z.number().int(),
  directedRematch: z.number().int(),
  houseBotVBot: z.number().int(),
  cleanUniverse: z.number().int(),
  cleanHvh: z.number().int(),
  /**
   * `cleanHvh ÷ cleanUniverse`, a RATIO in `[0, 1]` at 4 dp — the same wire format as
   * every other rate on this tab. `oracle.sql` prints this figure as a percentage, so a
   * harness comparing the two must scale by 100.
   *
   * Empty string when nothing was pairable in range: no rate exists, and `"0.0000"` would
   * assert one. Test `cleanUniverse === 0`.
   */
  hvhRate: z.string(),
});
export type ArenaOpsMatchmakingUniverseResponse = z.infer<typeof ArenaOpsMatchmakingUniverseResponseSchema>;
